import classNames from 'classnames';
import type {
  OverlayScrollbarsComponentProps,
  OverlayScrollbarsComponentRef,
} from 'overlayscrollbars-react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React, { forwardRef } from 'react';
import useIsDarkMode from '../utils/useIsDarkMode';
import * as styles from './ScrollArea.module.scss';

type ScrollAreaProps = OverlayScrollbarsComponentProps<'div'> & {
  direction?: 'vertical' | 'horizontal';
};

const ScrollArea = forwardRef<
  OverlayScrollbarsComponentRef<'div'>,
  ScrollAreaProps
>(({ className, direction = 'vertical', ...props }, ref) => {
  const isDarkMode = useIsDarkMode();

  return (
    <OverlayScrollbarsComponent
      className={classNames(styles.container, className)}
      options={{
        scrollbars: {
          theme: isDarkMode ? 'os-theme-light' : 'os-theme-dark',
        },
        overflow: { [direction === 'vertical' ? 'x' : 'y']: 'hidden' },
      }}
      ref={ref}
      defer
      {...props}
    />
  );
});

export default ScrollArea;
